import { mapGetters } from 'vuex'
export default {
    props:
    {
        item:Object,
    },
    computed:
    {
        ...mapGetters({
            fields: 'fields'
        }),
        startUrl()
        {
            if (this.item && this.item.client && this.item.client.channel)
            {
                return `https://${this.item.client.channel.domain}/`
            }
            return 'https://my.lover.ly/'
        },
    },
    data()
    {
        return {
            taggingOptions: 
            [
                {
                    id:0,
                    name:'Asdyy'
                },
                {
                    id:1,
                    name:'Asdyy1'
                },
            ],
            taggingSelected: [],
            priceTypes: 
            [
                {
                    id:0,
                    name:'Price per Lead'
                },
                {
                    id:1,
                    name:'Asdyy1'
                },
            ],
        }
    },
    watch:
    {
        '$route':
        {
            handler()
            {
                this.setData()
            },
            immediate: true
        }
    },
    methods: 
    {
        setData()
        {
            this.$store.dispatch('fieldsFetch')
        },
        selectPriceType(value)
        {
            this.item.price_type = value
        },
        save()
        {
            this.$store.dispatch(this.action.update, this.item).then(res=>{
                this.$emit('saved')
            })
        },
        preview()
        {
            this.$store.dispatch(this.action.update, this.item).then(res => {
                window.location.href = `${process.env.FRONTEND_URL}/preview/${this.item.url}`
            })
        },
        discard()
        {
            this.$router.push({ name: this.subPageName, params: {slug: 'live', page: 1, order: 'asc', sort: this.id}})
        },
        setField(isSet, field)
        {
            if (isSet)
            {
                this.item.fields.push(field)
            } else {
                this.item.fields = this.item.fields.filter(el => {
                    return field.id != el.id
                })
            }
        },

        getPivotField(field, key) {
            const fieldObj = this.item.fields.find(el => el.id === field.id)
            return fieldObj && fieldObj.pivot && fieldObj.pivot[key] ? fieldObj.pivot[key] : null
        },

        setPivotField(value, field, key) {
            const idx = this.item.fields.findIndex(el => {
                return field.id === el.id
            })

            const fieldInArray = this.item.fields[idx]

            const pivot = {
                field_id: fieldInArray.id,
                page_id: this.item.id,
                order: fieldInArray.pivot ? fieldInArray.pivot.order : 0,
                class: fieldInArray.pivot ? fieldInArray.pivot.class : 'col-sm-12',
            }

            pivot[key] = key === 'order' ? parseInt(value) : value

            this.item.fields[idx].pivot = pivot
        },
    },
    mounted()
    {
        this.$root.setLayout('layout-main')
    }
}



// WEBPACK FOOTER //
// ./src/mixins/edit/Settings.js